import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, DocumentChangeAction, DocumentSnapshot, Query } from '@angular/fire/firestore';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from '../auth.service';
import { Observable, of, from, forkJoin, combineLatest } from 'rxjs';
import { mergeMap, mergeAll, map, switchMap, take, reduce } from 'rxjs/operators';


@Component({
  selector: 'app-ventas-tropas',
  templateUrl: './ventas-tropas.component.html',
  styleUrls: ['./ventas-tropas.component.scss']
})
export class VentasTropasComponent implements OnInit, AfterViewInit {

  private operadoresCol: AngularFirestoreCollection<any>;
  public  operadores:    Observable<DocumentChangeAction<any>[]>;

  private simcardsCol: AngularFirestoreCollection<any>;
  public  simcards:    Observable<DocumentChangeAction<any>[]>;

  private clientesCol: AngularFirestoreCollection<any>;
  public  clientes:    Observable<DocumentChangeAction<any>[]>;  

  private portabilidadesCol: AngularFirestoreCollection<any>;
  public  portabilidades:    Observable<DocumentChangeAction<any>[]>;  

  private tropasCol: AngularFirestoreCollection<any>;
  public  tropas:    Observable<any>;
  public tropasMap: Map<String,any> = new Map<String,any>();

  public displayedColumns = [
    "id", "tipo", "estado", "tropa", "fechaEntrega", "nroTelSimcard",
    "fechaVenta", "cCedula", "cNombres", "cApellidos", "recarga",
    "pNroTelefono", "pNIP", "pOperador", "pFecha", 
    "fecAprRec", 
    "options"
  ];

  @ViewChild(MatDatepicker, {static: false}) pFecha: MatDatepicker<Date>;

  public  allItems: any[];
  //public allItems: Observable<any>;

  //public  dataSource = new MatTableDataSource<any>();

  public tropa:string = "";

  public tipo:string = "";

  public estado:string = "EN CURSO";

  public nroResultados:number = 0;

  public fechaDesde:Date = null;

  public fechaHasta:Date = null;  
  
  public tipoFiltro:string = "id";

  public valorFiltro:string = "";

  public simcard;

  constructor(
    private afFirestore: AngularFirestore, 
    private snackBar: MatSnackBar,
    public authService: AuthService){ 
      this.simcard = null;
  }

  ngOnInit() {
    this.isLoading = true;
    this.operadoresCol     = this.afFirestore.collection<any>("operadores");
    this.operadores        = this.operadoresCol.snapshotChanges();
    this.simcardsCol       = this.afFirestore.collection<any>("simcard", ref => ref.where("estado", "==", this.estado).limit(100).orderBy("fechaVenta", "desc") );
    this.simcards          = this.simcardsCol.valueChanges();
    this.clientesCol       = this.afFirestore.collection<any>("cliente");    
    this.portabilidadesCol = this.afFirestore.collection<any>("portabilidad");    
    this.tropasCol         = this.afFirestore.collection<any>("tropa");
    this.tropas            = this.tropasCol.valueChanges();
    this.tropas.subscribe(
      (lastTropas)=>{
        lastTropas.forEach(
          (tropa)=>{            
            this.tropasMap.set(tropa.uid, tropa);
          }
        );        
      }
    );
    this.nroResultados = 100;
  }

  private suscription = null;

  public isLoading:boolean = false;  

  ngAfterViewInit(){ 
    this.isLoading = true;
    if( this.suscription != null ){
      this.suscription.unsubscribe();
    }     
    this.suscription = this.simcards.pipe(
      mergeMap(
        simcards => { 
          return from(
            simcards
          )
          .pipe(
            map(
              simcard => {                
                return combineLatest(
                  [
                    of(simcard),
                    this.clientesCol.doc(simcard['id']).valueChanges(),
                    simcard["tipo"] === "PORTABILIDAD" ? this.portabilidadesCol.doc(simcard['id']).valueChanges() : of(undefined)
                  ]
                )
                .pipe(
                  take(1),
                  map(
                  ([simcard, cliente, portabilidad])=>{
                    return {
                      ...simcard,
                      cCedula      : cliente["cedula"],
                      cNombres     : cliente["nombres"],
                      cApellidos   : cliente["apellidos"],
                      pNroTelefono : portabilidad !== undefined ? portabilidad["nroTelefono"] : null,
                      pNIP         : portabilidad !== undefined ? portabilidad["nip"] : null,
                      pOperador    : portabilidad !== undefined ? portabilidad["operador"] : null,
                      pFecha       : portabilidad !== undefined && portabilidad["fecha"] != null ? portabilidad["fecha"].toDate() : null
                    };
                  }
                  )
                );                 
              }
            ),
            mergeAll(),
            reduce( (acc, one ) => acc.concat(one), [] )            
          );           
        }
      ),
    )
    .subscribe(
      simcards => {
        this.allItems  = simcards;
        this.isLoading = false;
      }
    );
  }  

  trackByUid(index, item) {
    //console.table(item);
    return item["id"];
  }

  public setFechaDesde(fechaDesde){  
    console.log("setFechaDesde("+fechaDesde+")");
    this.fechaDesde = fechaDesde;
    if( this.fechaDesde !== null ){
      this.fechaDesde.setHours(0);
      this.fechaDesde.setMinutes(0);
      this.fechaDesde.setSeconds(0);
      this.fechaDesde.setMilliseconds(0);
    }    
  }

  public setFechaHasta(fechaHasta){
    console.log("setFechaHasta("+fechaHasta+")");
    this.fechaHasta = fechaHasta;
    if( this.fechaHasta !== null ){
      this.fechaHasta.setHours(23);
      this.fechaHasta.setMinutes(59);
      this.fechaHasta.setSeconds(59);
      this.fechaHasta.setMilliseconds(999);
    }
  }

  applyFilter() {      
    this.isLoading = true;
    //
    this.simcardsCol = this.afFirestore.collection<any>(
      "simcard", 
      ref => {
        let ref2:Query = ref;
        let filter = false;
        let limit  = true; 
        if(this.tropa && this.tropa.length > 0){
          ref2 = ref2.where("tropa", "==", this.tropa);
          console.log("Tropa "+this.tropa)
          filter = true;
        }        
        if(this.tipo && this.tipo.length > 0){
          ref2 = ref2.where("tipo", "==", this.tipo);
          console.log("Tipo  "+this.tipo)
          filter = true;
        }
        //
        if(this.tipoFiltro && this.tipoFiltro.length > 0 && this.valorFiltro && this.valorFiltro.trim().length > 0){
          ref2 = ref2.where(this.tipoFiltro, "==", this.valorFiltro);
          filter = true;
          limit  = false;
        }
        //
        let orderBy = "fechaVenta";
        if(this.estado && this.estado.length > 0){
          ref2 = ref2.where("estado", "==", this.estado);
          console.log("Estado  "+this.estado)
          filter = true;          
          if( this.fechaDesde !== null && this.fechaHasta !== null ){
            switch(this.estado){
              case "INVENTARIO":{
                orderBy = "fechaEntrega";                
              }break;
              case "EN CURSO":{
                orderBy = "fechaVenta";                
              }break;
              default:{
                orderBy = "fechaAprRec";                
              }break;
            }
            console.log("Fechas "+orderBy+": "+this.fechaDesde+" - "+this.fechaHasta);
            ref2 = ref2.where(orderBy, ">=", this.fechaDesde).where(orderBy, "<=", this.fechaHasta);
          }          
        }
        if(!filter){
          ref2 = ref2.where("tropa", ">", "").orderBy("tropa");
          console.log("default filter by tropa  ");
        }           
        if(limit && this.nroResultados === 0){
          this.nroResultados = 200;
        }
        if(this.nroResultados > 0){
          ref2 = ref2.limit(this.nroResultados);
        }             
        return ref2.orderBy(orderBy, "desc");
      }
    );  
    this.simcards  = this.simcardsCol.valueChanges();    
    this.ngAfterViewInit();
  }  

  showUpdate(simcard){
    this.simcard = {...simcard};
  }

  showList(){
    this.simcard = null;
  }

  update(newState){
    var simcardRef = this.simcardsCol.doc(""+this.simcard.id).ref;
    var clienteRef = this.clientesCol.doc(""+this.simcard.id).ref;
    var portaRef   = this.portabilidadesCol.doc(""+this.simcard.id).ref;
    simcardRef.set(
        {
          "estado": newState != null ? newState : this.simcard.estado,
          "nroTelSimcard": this.simcard.nroTelSimcard,
          "fecAprRec": newState != null ? new Date() : null,
          "observaciones": this.simcard.observaciones
        }, 
        {merge: true}
      )
      .then(
        ()=>{
          return clienteRef.set(
            {
              "cedula": this.simcard.cCedula,
              "nombres": this.simcard.cNombres,
              "apellidos": this.simcard.cApellidos,
            },
            {merge: true}
          );
        }
      )
      .then(
        ()=>{
          if(this.simcard.tipo == "PORTABILIDAD"){
            return portaRef.set(
              {
                "nroTelefono": this.simcard.pNroTelefono,
                "nip": this.simcard.pNIP,
                "operador": this.simcard.pOperador,
                "fecha": this.simcard.pFecha,
              },
              {merge: true}
            );
          }
          return null;
        }
      )
      .then(
        ()=>{
          this.showList();
        }
      )
      .catch(
        (error)=>{
          this.snackBar.open("Error inesperado actualizando la venta","Entiendo",{duration: 2000});
        }
      ); 
  }

}
